export class IdinRequestDto {
  transactionId: string;
  entranceCode: string;
  issuerAuthenticationURL: string;
  transactionCreateDateTimestamp: Date;
  error: boolean;
  merchantReference: string;
}
